export function formatSlug(slug: string): string;
export function formatSlug(slug: null): null;
export function formatSlug(slug: string | null) {
  // Locale Homepages are given the slug "/", but the GROQ also adds "/", so this removes the extra "/" from homepages
  if (typeof slug === 'string' && slug.startsWith('//')) {
    return slug.substring(1, slug.length);
  }

  return slug;
}
